module.exports = __webpack_public_path__ + "img/02.1733f436.png";